/**
 * Funnel-event tracker.
 *
 * Pushes events to:
 *  1. the GTM `dataLayer` — consumed by Google Tag Manager (GTM-T4H6QZJC) on
 *     production, where you can build triggers/funnels and fire the Meta Pixel
 *     (e.g. map the `purchase` event to a Pixel "Purchase" conversion).
 *  2. PostHog — for product analytics.
 *
 * Safe no-op on preview/localhost where neither GTM nor PostHog is loaded
 * (the dataLayer array is created but nothing reads it).
 *
 * Standard events emitted across the app:
 *   view_pricing, cta_click, sign_up, begin_checkout, purchase, start_onboarding
 */
import { logUsage } from './usageTracker';

export function track(event, params = {}) {
  if (!event) return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (_) { /* ignore analytics errors */ }
  try {
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(event, params);
    }
  } catch (_) { /* ignore analytics errors */ }
  try {
    logUsage(event, params);
  } catch (_) { /* ignore analytics errors */ }
}
